export default "__VITE_ASSET__Bj3Y3zO8__"